/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */
import axios from "axios";
import {MainRequest} from "@/core/request"
import ServicePath from "@/core/ServicePath";

export default class HealthInsuranceRequest extends MainRequest{

    static listAllHealthInsurance() {
        return this.postSEC(ServicePath.HEALTH_INSURANCE_LIST_ALL)
    }

}